module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img57.135a6bbf.jpg";